import { ProductAccountingCategoryCreatePage } from '@/features/product-accounting-category/pages/ProductAccountingCategoryCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/admin/product-accounting-category/create',
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_accounting_category.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAccountingCategoryCreatePage,
})